let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dTkUK")).then(() => parcelRequire('2EEnO'));